import { render, staticRenderFns } from "./Trustee.vue?vue&type=template&id=68a5bba6&scoped=true&"
import script from "./Trustee.vue?vue&type=script&lang=ts&"
export * from "./Trustee.vue?vue&type=script&lang=ts&"
import style0 from "./Trustee.vue?vue&type=style&index=0&id=68a5bba6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a5bba6",
  null
  
)

export default component.exports